import { container } from "tsyringe";
import { AuthClient } from "../service/auth/authClient";
import { AuthService } from "../service/auth/authService";
import "reflect-metadata";
import { UsersService } from "../service/users/userService";
import { UserClient } from "../service/users/userClient";
import { BusinessPartnerClient } from "../service/businessPartners/businessPartnersClient";
import { BusinessPartnerService } from "../service/businessPartners/businessPartnersService";
import { OrdersService } from "../service/orders/ordersService";
import { OrdersClient } from "../service/orders/ordersClient";
import { ItemsService } from "../service/items/itemsService";
import { ItemsClient } from "../service/items/itemsClient";
import { ProfitCenterClient } from "../service/profitCenter/profitCenterClient";
import { ProfitCentersService } from "../service/profitCenter/profitCenterService";

export const RegisterServices = () => {
	container.register("AuthClient", AuthClient);
	container.register("AuthService", AuthService);

	container.register("UsersClient", UserClient);
	container.register("UsersService", UsersService);

	container.register("BusinessPartnerClient", BusinessPartnerClient);
	container.register("BusinessPartnerService", BusinessPartnerService);

	container.register("OrdersClient", OrdersClient);
	container.register("OrdersService", OrdersService);

	container.register("ItemsService", ItemsService);
	container.register("ItemsClient", ItemsClient);

	container.register("ProfitCenterClient", ProfitCenterClient);
	container.register("ProfitCentersService", ProfitCentersService);
};

export { container };
